// extracted by mini-css-extract-plugin
export default {"wrapper":"Dashboard_wrapper__A9p31"};